import { ChatBackgroundPattern, ChatBackgroundType } from 'APP/constants/appearance';
import Entities from 'STORE';
import { Thread } from 'STORE/Groups/Thread';

import styles from '../ChatBackground.styles.m.css';

const PREFIX = 'chat-background';

export function getChatBackgroundClassName(pattern: ChatBackgroundPattern): string {
  return `${PREFIX}-${pattern}`;
}

export function useChatBackgroundClassName(): string {
  const groupId = Entities.GroupsStore.activeGroupId ?? null;

  const group = groupId ? Entities.GroupsStore.getGroupById(groupId) : null;

  const entityIdForBackground =
    group instanceof Thread && group.parentGroup ? group.parentGroup.id : groupId;

  const background = Entities.appearance.getChatBackgroundForEntity(entityIdForBackground);

  if (background.type === ChatBackgroundType.Pattern) {
    return styles[getChatBackgroundClassName(background.background)];
  }

  return '';
}
